import React            from 'react';
import {getTranslation} from './CamShows';
import ReloadHelper     from "../../utils/ReloadHelper";
import { generateKey }  from '../../utils/CommonUtils';


class CamShowsFAQ extends React.PureComponent {

    onClick(link, e) {
        ReloadHelper.reload(link, e);
    }

    getFAQs() {
        const faqs = [];
        let hasFAQ = true;
        let i      = 1;

        while(hasFAQ) {
            const headline = getTranslation('faq-headline-' + i); 
            const text     = getTranslation('faq-text-' + i); 
            if (headline && text) {
                const textSplitted = text.split('%s'); 
                const textArray    = [];
                const linksCount   = textSplitted.length - 1;

                if (linksCount > 0) {
                    const links = [];
                    for (let j = 0; j < linksCount; j++) {
                        const link = getTranslation("faq-text-" + i + "-link-" + (j + 1));
                        links.push(<a key={generateKey('camshows-faq-link', links.length)} href={link} onClick={(e) => this.onClick(link, e)}>{getTranslation("faq-text-" + i + "-link-text-" + (j + 1))}</a>);
                    }
                    textSplitted.map((item, index) => {
                        textArray.push(item);
                        links[index] && textArray.push(links[index]);
                    });
                } else {
                    textArray.push(text);
                }
                faqs.push({headline, text: textArray});
                i++;
            } else {
                hasFAQ = false;
            }
        }

        return faqs;
    }

    showText(e, index) {
        const parent = document.querySelector('.cam-shows__faq-item--' + index);
        const icon   = document.querySelector('.cam-shows__faq-icon--' + index);
        if (parent.classList.contains("cam-shows__faq-item--active")){
            parent.classList.remove('cam-shows__faq-item--active');
            icon.classList.remove("cam-shows__faq-icon--animation");
            
        } else {
            parent.classList.add('cam-shows__faq-item--active');
            icon.classList.add("cam-shows__faq-icon--animation");
        }
    }

  render() {
    const faqs = this.getFAQs();

    return (
      <div className='cam-shows__faq'>
        <h2 className='cam-shows__faq-title'>FAQ</h2>
        <ul className='cam-shows__faq-list'>
            {
                faqs.map((faq, index) => (
                    <li key={generateKey('camshows-faq', index)} className={'cam-shows__faq-item cam-shows__faq-item--' + index}>
                        <div className='cam-shows__faq-headline__wrapper' onClick={(e) => this.showText(e, index)}>
                            <h3 className='cam-shows__faq-headline'>{faq.headline}</h3>
                            <i className={'cam-shows__faq-icon icon cam-shows__faq-icon--' + index} />
                        </div>
                        <div className='cam-shows__faq-text'>
                            {faq.text}
                        </div>
                    </li>
                ))
            }
        </ul>
      </div>
    );
  }
}

export default CamShowsFAQ;